import { FC } from "react";
import { motion } from "framer-motion";

interface StepperProps {
  steps: string[];
  currentStep: number;
}

const Stepper: FC<StepperProps> = ({ steps, currentStep }) => {
  return (
    <div className="flex items-center justify-center mb-8">
      {steps.map((step, index) => (
        <div key={index} className="flex items-center">
          <motion.div
            className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold ${
              index <= currentStep
                ? "bg-blue-600 text-white dark:bg-blue-500"
                : "bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-300"
            }`}
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.3 }}
          >
            {index + 1}
          </motion.div>
          <span
            className={`ml-2 text-sm font-medium ${
              index <= currentStep
                ? "text-gray-900 dark:text-gray-100"
                : "text-gray-500 dark:text-gray-400"
            }`}
          >
            {step}
          </span>
          {index < steps.length - 1 && (
            <div
              className={`w-16 h-1 mx-4 ${
                index < currentStep
                  ? "bg-blue-600 dark:bg-blue-500"
                  : "bg-gray-200 dark:bg-gray-700"
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default Stepper;
